<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-items-center">
    <h2 class="question-title-v2 tw-mb-8 tw-text-center">
      {{ question.question }}
    </h2>
    <div class="tw-flex tw-w-full tw-max-w-lg tw-flex-col tw-gap-3">
      <button
        v-for="opt in answerList"
        :key="String(opt.id)"
        type="button"
        class="tw-w-full tw-rounded-lg tw-border tw-py-4 tw-text-center tw-text-onyx tw-transition-colors"
        :class="isSelected(opt)
          ? 'tw-border-lavender-purple'
          : 'tw-border-silver-sand'"
        :disabled="disabled"
        @click="$emit('choose', opt)"
      >
        {{ opt.name }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Stack sub-layout of the `single` follow-up: 3+ options as full-width rounded
 * rows. Controlled — highlight is driven by `selectedId`; clicking emits
 * `choose`. Default layout when `displaymode` is missing or unrecognized.
 */
export default {
  name: 'FollowupV7SingleStack',

  props: {
    question: {
      type: Object,
      required: true,
    },
    selectedId: {
      type: [String, Number, Boolean],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    answerList() {
      return this.question.answerlist || [];
    },
  },

  methods: {
    isSelected(opt) {
      return this.selectedId != null && String(this.selectedId) === String(opt.id);
    },
  },
};
</script>
